
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/viewcart",
      function () {
        return require("private-next-pages/viewcart/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/viewcart"])
      });
    }
  